import React from 'react';
import './Footer.css';
import { motion } from 'framer-motion';

const Footer = () => {
  const logoUrl = "https://blacksalt.ascentbw.com/Images/TagLogo.png";

  const navLinks = [
    { name: "ABOUT", href: "#about" },
    { name: "GALLERY", href: "#gallery" },
    { name: "SALE", href: "#sale" },
    { name: "CONTACT", href: "#contact" },
  ];

  return (
    <motion.footer
      className="site-footer"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
    >
      <div className="footer-inner">

        {/* Top Row: Logo + Nav */}
        <div className="footer-top">
          <div className="footer-logo">
            <img src={logoUrl} alt="TAG Logo" />
          </div>
          <nav className="footer-nav">
            {navLinks.map((link) => (
              <a key={link.name} href={link.href}>{link.name}</a>
            ))}
          </nav>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Middle Row: Address | Phone | Email */}
        <div className="footer-contact-row">
          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
            </div>
            <div className="footer-contact-text">
              <span className="footer-contact-label">Our Address</span>
              <span>49, Gangadeeshwar Koil St,<br />Purasaiwakkam, Chennai,<br />Tamil Nadu 600084</span>
            </div>
          </div>

          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.13 12.8a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.128.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.572 2.81.7A2 2 0 0 1 22 16.92z"></path>
              </svg>
            </div>
            <div className="footer-contact-text">
              <span className="footer-contact-label">Phone</span>
              <span>044-26420956</span>
              <span>+91-7947151361</span>
            </div>
          </div>

          <div className="footer-contact-item">
            <div className="footer-contact-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                <polyline points="22,6 12,13 2,6"></polyline>
              </svg>
            </div>
            <div className="footer-contact-text">
              <span className="footer-contact-label">Email</span>
              <a href="mailto:tagtrousers@gmail.com">tagtrousers@gmail.com</a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom Row: Copyright */}
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} TAG Menswear. All rights reserved.</p>
          <div className="footer-legal-links">
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
        </div>

      </div>
    </motion.footer>
  );
};

export default Footer;
